import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { Promote } from 'views/promote'

const PromotePage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'promote.meta.title' })}
        description={formatMessage({ id: 'promote.meta.description' })}
      />
      <Header bordered={false} />
      <Promote />
      <Footer />
    </>
  )
}

export default PromotePage
